const icons = {};
icons.borderRadiusNone = (
	<svg viewBox="0 0 104 104">
		<defs>
			<rect height="100" width="100" x="0" y="0" />
		</defs>
		<g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="matrix(1 0 0 1 2 2)">
				<g>
					<mask fill="#fff">
						<use xlinkHref="#path-1" />
					</mask>
					<use stroke="#fff" strokeWidth="3" xlinkHref="#path-1" />
					<rect
						height="118"
						stroke="currentColor"
						width="118"
						x="-51"
						y="-48"
						strokeWidth="10"
					/>
				</g>
			</g>
		</g>
	</svg>
);
icons.borderRadiusSmall = (
	<svg viewBox="0 0 104 104">
		<defs>
			<rect height="100" width="100" x="0" y="0" />
		</defs>
		<g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="matrix(1 0 0 1 2 2)">
				<g>
					<mask fill="#fff">
						<use xlinkHref="#path-1" />
					</mask>
					<use stroke="#fff" strokeWidth="3" xlinkHref="#path-1" />
					<rect
						height="118"
						rx="2"
						stroke="currentColor"
						width="118"
						x="-51"
						y="-48"
						strokeWidth="10"
					/>
				</g>
			</g>
		</g>
	</svg>
);
icons.borderRadiusMedium = (
	<svg viewBox="0 0 104 104">
		<defs>
			<rect height="100" width="100" x="0" y="0" />
		</defs>
		<g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="matrix(1 0 0 1 2 2)">
				<g>
					<mask fill="#fff">
						<use xlinkHref="#path-1" />
					</mask>
					<use stroke="#fff" strokeWidth="3" xlinkHref="#path-1" />
					<rect
						height="118"
						rx="10"
						stroke="currentColor"
						width="118"
						x="-51"
						y="-48"
						strokeWidth="10"
					/>
				</g>
			</g>
		</g>
	</svg>
);
icons.borderRadiusLarge = (
	<svg viewBox="0 0 104 104">
		<defs>
			<rect height="100" width="100" x="0" y="0" />
		</defs>
		<g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="matrix(1 0 0 1 2 2)">
				<g>
					<mask fill="#fff">
						<use xlinkHref="#path-1" />
					</mask>
					<use stroke="#fff" strokeWidth="3" xlinkHref="#path-1" />
					<rect
						height="118"
						rx="20"
						stroke="currentColor"
						width="118"
						x="-51"
						y="-48"
						strokeWidth="10"
					/>
				</g>
			</g>
		</g>
	</svg>
);
icons.borderRadiusXLarge = (
	<svg viewBox="0 0 104 104">
		<defs>
			<rect height="100" width="100" x="0" y="0" />
		</defs>
		<g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="matrix(1 0 0 1 2 2)">
				<g>
					<mask fill="#fff">
						<use xlinkHref="#path-1" />
					</mask>
					<use stroke="#fff" strokeWidth="3" xlinkHref="#path-1" />
					<rect
						height="118"
						rx="50"
						stroke="currentColor"
						width="118"
						x="-51"
						y="-48"
						strokeWidth="10"
					/>
				</g>
			</g>
		</g>
	</svg>
);
icons.borderWidthNone = (
	<svg viewBox="0 0 104 104">
		<path
			d="m16 16h68v68h-68z"
			fill="none"
			transform="matrix(1 0 0 1 2 2)"
		/>
	</svg>
);
icons.borderWidthSmall = (
	<svg viewBox="0 0 104 104">
		<defs>
			<rect height="100" width="100" x="0" y="0" />
		</defs>
		<g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="matrix(1 0 0 1 2 2)">
				<g>
					<mask fill="#fff">
						<use xlinkHref="#path-1" />
					</mask>
					<use stroke="#fff" strokeWidth="3" xlinkHref="#path-1" />
					<rect
						height="68"
						stroke="currentColor"
						width="68"
						x="16"
						y="16"
					/>
				</g>
			</g>
		</g>
	</svg>
);
icons.borderWidthMedium = (
	<svg viewBox="0 0 104 104">
		<defs>
			<rect height="100" width="100" x="0" y="0" />
		</defs>
		<g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="matrix(1 0 0 1 2 2)">
				<g>
					<mask fill="#fff">
						<use xlinkHref="#path-1" />
					</mask>
					<use stroke="#fff" strokeWidth="3" xlinkHref="#path-1" />
					<rect
						height="68"
						stroke="currentColor"
						width="68"
						x="16"
						y="16"
						strokeWidth="4"
					/>
				</g>
			</g>
		</g>
	</svg>
);
icons.borderWidthLarge = (
	<svg viewBox="0 0 104 104">
		<defs>
			<rect height="100" width="100" x="0" y="0" />
		</defs>
		<g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="matrix(1 0 0 1 2 2)">
				<g>
					<mask fill="#fff">
						<use xlinkHref="#path-1" />
					</mask>
					<use stroke="#fff" strokeWidth="3" xlinkHref="#path-1" />
					<rect
						height="68"
						stroke="currentColor"
						width="68"
						x="16"
						y="16"
						strokeWidth="6"
					/>
				</g>
			</g>
		</g>
	</svg>
);
icons.borderWidthXLarge = (
	<svg viewBox="0 0 104 104">
		<defs>
			<rect height="100" width="100" x="0" y="0" />
		</defs>
		<g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="matrix(1 0 0 1 2 2)">
				<g>
					<mask fill="#fff">
						<use xlinkHref="#path-1" />
					</mask>
					<use stroke="#fff" strokeWidth="3" xlinkHref="#path-1" />
					<rect
						height="68"
						stroke="currentColor"
						width="68"
						x="16"
						y="16"
						strokeWidth="10"
					/>
				</g>
			</g>
		</g>
	</svg>
);

icons.boxShadowNone = (
	<svg viewBox="0 0 104 104">
		<path
			d="m16 16h68v68h-68z"
			fill="#fff"
			stroke="#000"
			transform="matrix(1 0 0 1 2 2)"
			strokeWidth="3"
		/>
	</svg>
);
icons.boxShadowSmall = (
	<svg viewBox="0 0 104 104">
		<g fill="none" transform="matrix(1 0 0 1 2 2)">
			<path d="m12 13h68v68h-68z" fill="#d8d8d8" />
			<path
				d="m6 7h68v68h-68z"
				fill="#fff"
				stroke="#000"
				strokeWidth="3"
			/>
		</g>
	</svg>
);
icons.boxShadowMedium = (
	<svg viewBox="0 0 104 104">
		<g fill="none" transform="matrix(1 0 0 1 2 2)">
			<path d="m19 20h68v68h-68z" fill="#d8d8d8" />
			<path
				d="m6 7h68v68h-68z"
				fill="#fff"
				stroke="#000"
				strokeWidth="3"
			/>
		</g>
	</svg>
);
icons.boxShadowLarge = (
	<svg viewBox="0 0 104 104">
		<g fill="none" transform="matrix(1 0 0 1 2 2)">
			<path d="m23 24h68v68h-68z" fill="#d8d8d8" />
			<path
				d="m6 7h68v68h-68z"
				fill="#fff"
				stroke="#000"
				strokeWidth="3"
			/>
		</g>
	</svg>
);
icons.boxShadowXLarge = (
	<svg viewBox="0 0 104 104">
		<g fill="none" transform="matrix(1 0 0 1 2 2)">
			<path d="m32 32h68v68h-68z" fill="#d8d8d8" />
			<path
				d="m6 7h68v68h-68z"
				fill="#fff"
				stroke="#000"
				strokeWidth="3"
			/>
		</g>
	</svg>
);
icons.borderWidth = (
	<svg
		fill="currentColor"
		height="20px"
		version="1.1"
		viewBox="0 0 24 24"
		width="20px"
		x="0px"
		y="0px"
	>
		<title>content_040-no_border-table-cell-square</title>
		<desc>Created with Sketch.</desc>
		<g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g fill="currentColor" transform="matrix(1 0 0 1 -476 -188)">
				<g transform="matrix(1 0 0 1 477 189)">
					<rect height="1" width="2" x="0" y="0" />
					<rect height="1" width="2" x="8" y="0" />
					<rect height="1" width="2" x="4" y="0" />
					<rect height="1" width="2" x="12" y="0" />
					<rect height="2" width="1" x="0" y="7" />
					<rect height="2" width="1" x="0" y="3" />
					<rect height="2" width="1" x="20" y="8" />
					<rect height="2" width="1" x="20" y="0" />
					<rect height="2" width="1" x="20" y="4" />
					<rect height="2" width="1" x="0" y="11" />
					<rect height="2" width="1" x="0" y="15" />
					<rect height="2" width="1" x="0" y="19" />
					<rect height="2" width="1" x="20" y="12" />
					<rect height="2" width="1" x="20" y="16" />
					<rect height="1" width="2" x="19" y="20" />
					<rect height="1" width="2" x="3" y="20" />
					<rect height="1" width="2" x="7" y="20" />
					<rect height="1" width="2" x="11" y="20" />
					<rect height="1" width="2" x="16" y="0" />
					<rect height="1" width="2" x="15" y="20" />
				</g>
			</g>
		</g>
	</svg>
);
icons.borderRadius = (
	<svg height="20px" viewBox="0 0 66 66" width="20px">
		<path
			d="m457 596.97658v5.02342c0 .552285-.447715 1-1 1h-12c-.552285 0-1-.447715-1-1v-5h-14.996435c-6.077067 0-11.003565-4.926533-11.003565-11.003565v-37.99287c0-6.077067 4.926533-11.003565 11.003565-11.003565h37.99287c6.077067 0 11.003565 4.926533 11.003565 11.003565v14.996435h5c.552285 0 1 .447715 1 1v12c0 .552285-.447715 1-1 1h-5.023422c-.506685 10.803114-9.172511 19.469882-19.976578 19.97658zm-12 4.02342h10v-10h-10zm26-26h10v-10h-10zm-28 20v-5c0-.552285.447715-1 1-1h12c.552285 0 1 .447715 1 1v4.974104c9.699148-.5031 17.471015-8.275803 17.974102-17.974104h-4.974102c-.552285 0-1-.447715-1-1v-12c0-.552285.447715-1 1-1h5v-14.996435c0-4.972466-4.03107-9.003565-9.003565-9.003565h-37.99287c-4.972466 0-9.003565 4.03107-9.003565 9.003565v37.99287c0 4.972466 4.03107 9.003565 9.003565 9.003565z"
			transform="matrix(1 0 0 1 -417 -537)"
			fillRule="evenodd"
		/>
	</svg>
);
icons.boxShadow = (
	<svg
		height="20px"
		viewBox="0 0 100 100"
		width="20px"
		enableBackground="new 0 0 100 100"
	>
		<path d="m92.5 21.233h-13.733v-13.733c0-1.381-1.119-2.5-2.5-2.5h-68.767c-1.381 0-2.5 1.119-2.5 2.5v68.767c0 1.381 1.119 2.5 2.5 2.5h13.733v13.733c0 1.381 1.119 2.5 2.5 2.5h68.767c.164 0 .328-.017.489-.049.075-.015.145-.043.217-.064.084-.025.168-.044.249-.077.086-.036.164-.084.245-.129.062-.034.126-.061.185-.101.275-.183.51-.419.694-.694.039-.058.065-.122.099-.182.045-.082.094-.161.13-.248.033-.081.052-.165.077-.248.022-.073.05-.143.065-.219.033-.161.05-.325.05-.489v-68.767c0-1.38-1.119-2.5-2.5-2.5zm-82.5 52.534v-63.767h63.767v13.733 50.033h-50.034-13.733zm16.233 16.233v-7.698l7.699 7.698zm14.769 0-11.233-11.233h6.063l11.233 11.233zm13.133 0-11.233-11.233h6.063l11.233 11.233zm13.134 0-11.234-11.233h6.063l11.234 11.233zm13.133 0-11.234-11.233h6.063l11.234 11.233zm9.598-3.535-11.233-11.234v-6.063l11.233 11.234zm0-13.133-11.233-11.234v-6.063l11.233 11.234zm0-13.134-11.233-11.233v-6.063l11.233 11.233zm0-13.133-11.233-11.233v-6.063l11.233 11.233zm0-13.133-7.698-7.698h7.698z" />
	</svg>
);
icons.plugin = (
	<svg
		height="20px"
		viewBox="0 0 100 100"
		width="20px"
		enableBackground="new 0 0 100 100"
	>
		<path
			d="m27.751 67.15-.001-4.54-16.454.033c-3.027.017-5.475-2.431-5.478-5.47v-35.232c.003-3.014 2.451-5.462 5.453-5.462 1.313 0 2.521.469 3.441 1.225l15.019 15.069c1.434 1.484 2.331 3.479 2.318 5.568l-.033 20.008 4.595.026-.001-15.947c.011-2.975 2.459-5.423 5.51-5.43l16.99.028v-4.742l-19.718.03c-2.173 0-4.168-.897-5.582-2.264l-15.39-15.078c-1.075-.938-1.807-2.414-1.807-4.055 0-3.002 2.448-5.45 5.526-5.415h35.67c3.099-.035 5.548 2.413 5.544 5.212l.024 17.276 4.386.056-.01-11.806c-.002-3.042 2.519-5.49 5.442-5.49 1.37 0 2.638.538 3.672 1.435l10.798 10.549c.974.952 1.913 2.361 1.913 4.096 0 3.002-2.448 5.457-5.33 5.467l-12.163.043v4.658l16.678-.037c2.984-.007 5.433 2.419 5.418 5.451l-.011 35.698c-.001 3.088-2.445 5.537-5.447 5.537-1.595 0-2.99-.732-3.995-1.735l-14.585-14.56c-1.447-1.444-2.376-3.411-2.377-5.455l-.004-20.661-4.414.084.016 15.931c.015 2.96-2.433 5.4-5.411 5.392l-17.076-.047.004 4.596 19.44-.016c2.225-.002 4.206.933 5.57 2.301l15.985 16.035c.868.87 1.242 2.163 1.242 3.476 0 3.002-2.448 5.45-5.546 5.471l-35.508.041c-3.102.02-5.55-2.428-5.507-5.539l.068-17.508-4.598.029.023 11.997c.013 3.031-2.435 5.479-5.437 5.479-1.407 0-2.692-.538-3.642-1.401l-11.506-11.45c-.76-.919-1.215-2.126-1.187-3.44.063-3.002 2.448-5.45 5.331-5.482l12.135-.032m-.022-28.553c-.029-1.116-.492-2.146-1.173-2.829l-14.453-14.638c-.217-.23-.506-.36-.824-.36-.637 0-1.156.519-1.163 1.258v35.089c.008.726.527 1.245 1.213 1.233l16.429-.032zm30.179 19.754-16.997-.009-.004-15.875c.016-.652.535-1.171 1.199-1.183l16.983.033-.007 15.87c.011.657-.509 1.164-1.174 1.164zm20.542 29.772-15.306-15.381c-.709-.712-1.703-1.255-2.816-1.257l-19.44-.034-.035 17.565c-.039.688.481 1.207 1.101 1.192l35.763-.041c.594-.025 1.113-.544 1.113-1.181 0-.319-.128-.61-.38-.863zm-41.859-25.516-.005 4.515-4.553.053.017-4.515zm-8.824 20.809.01-11.91-12.062-.013c-.617.014-1.136.533-1.136 1.17 0 .318.13.607.33.829l10.697 10.625c.263.34.615.543 1.013.543.637-.001 1.156-.52 1.148-1.244zm31.303-72.658.019 17.284-19.526-.021c-1.164-.004-2.194-.467-2.942-1.164l-15.306-15.09c-.199-.104-.402-.456-.402-.854 0-.637.519-1.156 1.158-1.125h35.88c.598-.031 1.118.488 1.119.97zm8.7 26.237.028-4.63-4.414-.056v4.658zm17.168-10.999-10.825-10.723c-.162-.252-.514-.455-.912-.455-.637 0-1.156.519-1.152 1.203l.043 12.021 12.037-.038c.642-.022 1.161-.541 1.161-1.178.001-.318-.129-.607-.352-.83zm4.97 16.382c0-.637-.519-1.156-1.247-1.131l-16.597.014-.004 20.39c0 .834.51 1.821 1.194 2.514l14.571 14.741c.201.203.507.443.904.443.637 0 1.156-.519 1.157-1.168l.001-35.906"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	</svg>
);
icons.button = (
	<svg viewBox="0 0 16 16">
		<path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z" />
	</svg>
);
export default icons;
